<template>
  <div
    v-if="
      selectedPlan !== null &&
        selectedPlan !== undefined &&
        planOptions !== null &&
        planOptions !== undefined
    "
  >
  <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.delete" persistent max-width="400">
      <material-card
        v-if="selectedItem"
        :title="
          $t('views.unionlocals.delete_union_local_{0}', [selectedItem.Name])
        "
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <local-effective-dialog
      :identityId="selectedItem.Id"
      :isNew="isNew"
      :model="dialogs.edit"
      @close="close"
      :unions="unions"
    />
    <local-untracked-dialog
      :identityId="selectedItem.Id"
      :model="dialogs.correctInformation"
      @close="dialogs.correctInformation=false; $refs.table.getDataAsync()"
    />
    <material-card
      :title="$t('views.unionlocals.union_locals')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="mdi-lan"
    >
      <pbas-data-table
        :exporters="$exporters"
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="union_locals"
        :identifier="'unionLocalsTable' + selectedPlan.Id"
        @error="error = $event"
        :canExpand="(item) => item.HasHistory"
        :showExpand="true"
        :generateProviderForExpanded="(item) => generateHistoryProvider(item)"
        :showSelect="false"
      ></pbas-data-table>
    </material-card>
    <contacts
      ref="contacts"
      entity="UnionLocal"
      :relatedHeaders="unionLocalContactsHeaders"
      @refresh="$refs.table.getDataAsync()"
      :identifier="'unionLocalContacts' + selectedPlan.Id"
      :rootUrl="'plans/' + this.selectedPlan.Id + '/union-locals-contacts'"
    ></contacts>

    <v-snackbar v-model="snackbar" color="success" :timeout="2500">
      {{ $t("globals.success") }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Contacts from "../components/Contacts";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import { ODataHeader, ODataString } from "pbas-vue-components";
import UnionLocalsHeaders from "../headers/UnionLocals";
import UnionLocalsHistoryHeaders from "../headers/UnionLocalsHistory";
import { locker } from "../mixins/locker";
import { translate2 } from "../trans2";
import { planSetter } from "../mixins/planSetter";
import LocalEffectiveDialog from "../components/UnionLocals/LocalEffectiveDialog.vue";
import LocalUntrackedDialog from "../components/UnionLocals/LocalUntrackedDialog.vue";

export default {
  components: {
    ErrorHandler,
    Contacts,
    LocalEffectiveDialog,
    LocalUntrackedDialog
  },
  mixins: [locker, planSetter],
  data() {
    return {
      selectedItem: {},
      error: null,
      unionLocalContactsHeaders: [
        new ODataHeader({
          title: "components.contacts.union_local",
          type: new ODataString("UnionLocal/Current/Name"),
          sortable: true,
          visible: true,
          searchable: true,
          version: 1,
          orderByKey: "Name",
        }),
        new ODataHeader({
          type: new ODataString("UnionLocal/Current/Id"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
      ],
      provider: undefined,
      saving: false,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.edit(item),
          visible: (item) =>
            !this.selectedPlan.Current.IsTesting &&
            this.role.indexOf("Broker Plan Manager") > -1,
        },
        {
          name: "editUntracked",
          icon: "spellcheck",
          title: "globals.correct_information",
          handler: (item) => {
            this.selectedItem = item;
            this.dialogs.correctInformation = true;
          },
          visible: (item) =>
            !this.selectedPlan.Current.IsTesting &&
            this.role.indexOf("Broker Plan Manager") > -1,
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: async (item) => {
            this.selectedItem = item;
            this.dialogs.delete = true;
          },
          visible: (item) =>
            !this.selectedPlan.Current.IsTesting &&
            this.role.indexOf("Broker Plan Manager") > -1,
        },
      ],
      snackbar: false,
      dialogs: {
        edit: false,
        delete: false,
        correctInformation: false,
      },
      defaultContact: {
        Name: "",
        Email: "",
        Status: null,
      },
      contact: {},
      isNew: false,
      unions: [],
      loading: false
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options", "planOptions"]),
    floatActions() {
      if (
        (this.selectedPlan && this.selectedPlan.Current.IsTesting)
      ) {
        return [];
      }
      if (this.role.indexOf("Broker Plan Creator") > -1 || this.role.indexOf("Broker Plan Manager") > -1) {
        return [
          {
            name: "addItem",
            icon: "add",
            color: this.$vuetify.theme.themes.light.success,
            text: "globals.add_new",
            handler: () => this.addItem(),
          },
        ];
      }
      return [];
    },
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["settings"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", ["deleteUnionLocal", "getPlanUnions"]),
    trans(item, field) {
      return translate2(item, field);
    },
    async tryDelete() {
      this.saving = true;
      try {
        await this.deleteUnionLocal({
          planIdentityId: this.selectedPlan.Id,
          id: this.selectedItem.Id,
        });
        this.snackbar = true;
        this.dialogs.delete = false;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async loadPlanData() {
      this.loading = true;
      let url = "plans/" + this.selectedPlan.Id + "/union-locals";
      this.provider = new ODataProvider(
        this.$axiosHttp,
        url,
        UnionLocalsHeaders
      );
      try {
        this.unions = (await this.getPlanUnions({planIdentityId: this.selectedPlan.Id})).data.value;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async edit(item) {
      this.selectedItem = item;
      this.isNew = false;
      this.dialogs.edit = true;
    },
    addItem() {
      this.selectedItem = {};
      this.isNew = true;
      this.dialogs.edit = true;
    },
    close() {
      this.dialogs.edit = false;
      this.isNew = false;
      this.contact = JSON.parse(JSON.stringify(this.defaultContact));
      if (this.$refs.form) this.$refs.form.resetValidation();
      if (this.$refs.contactform) this.$refs.contactform.resetValidation();
        this.$refs.table.getDataAsync();
        this.$refs.contacts.reload();
    },
    generateHistoryProvider(item) {
      const url =
        "plans/" +
        this.selectedPlan.Id +
        "/union-locals/" +
        item.Id +
        "/history";
      return new ODataProvider(this.$axiosHttp, url, UnionLocalsHistoryHeaders);
    },
  },
};
</script>
